// extracted by mini-css-extract-plugin
export default {"root":"MenuToggle_root__Ttc3v","line1":"MenuToggle_line1__47AqT","line2":"MenuToggle_line2__fyCA3","line3":"MenuToggle_line3__KmzyN","active":"MenuToggle_active__G3vvw"};